import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import FaqItem from "./FAQItem";

function FrequentlyAskedQuestions(props) {
  const { content } = props;

  const [activeCategoryIndex, setActiveCategoryIndex] = useState(0);

  return (
    <article className="FrequentlyAskedQuestions">
      <nav className="FrequentlyAskedQuestions-tabs">
        {content.map((category, i) => {
          const tabClassName = classNames("FrequentlyAskedQuestions-tab", {
            active: activeCategoryIndex === i,
          });

          return (
            <a
              key={`faq-tab-${i}`}
              onClick={() => setActiveCategoryIndex(i)}
              className={tabClassName}
            >
              {category.categoryTitle}
            </a>
          );
        })}
      </nav>

      {content.map((category, i) => {
        const categoryClassName = classNames(
          "FrequentlyAskedQuestions-category",
          { active: i === activeCategoryIndex },
          { singleContent: content.length === 1 },
        );

        return (
          <article
            key={`cat-${i}`}
            className={categoryClassName}
            data-testid="FrequentlyAskedQuestions-category"
          >
            <h3 className="FrequentlyAskedQuestions-category-title">
              {category.categoryTitle}
            </h3>
            {category.items.map((faqItem, j) => (
              <FaqItem
                key={`cat-${i}-item-${j}`}
                title={faqItem.title}
                content={faqItem.content}
              />
            ))}
          </article>
        );
      })}
    </article>
  );
}

FrequentlyAskedQuestions.propTypes = {
  content: PropTypes.arrayOf(
    PropTypes.shape({
      categoryTitle: PropTypes.string,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          content: PropTypes.string,
        }),
      ),
    }),
  ),
};

export default FrequentlyAskedQuestions;
